var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 623,
    height: 623,
    viewBox: "0 0 623 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.560059 31.3333C0.560059 14.1507 14.4867 0.223999 31.6694 0.223999H311.669V62.4427H62.7761V560.229H560.563V311.336H622.781V591.336C622.781 608.519 608.855 622.445 591.672 622.445H31.6721C14.4894 622.445 0.562724 608.519 0.562724 591.336L0.560059 31.3333Z",
    fill: "#219CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M622.773 91.28L531.721 0.222656L471.763 60.176L562.825 151.228L622.773 91.28Z",
    fill: "#219CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.44 373.56L349.601 364.451L518.828 195.237L427.771 104.18L258.557 273.407L249.44 373.56Z",
    fill: "#219CFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.08fe8068afb2aa219cf30da58d3aa454.svg";
export { ForwardRef as ReactComponent };